import catalog from '../../../../SKILLs/pptx/references/styles/styles.json';

/** 把已选风格、密度和品牌色通过现有 answers 协议回传，未知参数直接拒绝。 */
export function buildPptxStyleAnswer(id: string, density: string, brand?: string): string {
  const style = catalog.styles.find(item => item.id === id);
  const densityEntry = catalog.densities.find(item => item.id === density);
  if (!style || !densityEntry) throw new Error('Unknown PPTX style or density');
  const accent = brand?.trim() ? brand.trim().replace(/^#/, '').toUpperCase() : style.tokens.accent;
  if (!/^[0-9A-F]{6}$/.test(accent)) throw new Error('Invalid PPTX brand color');
  return [
    `${style.id} ${style.name} | 密度:${densityEntry.name} | 品牌色:${brand?.trim() ? `#${accent}` : '默认'}`,
    '生成约束（保留原任务内容与页数；以下只确定视觉，不新增研究结论）：',
    `使用原生可编辑 PPTX；读取 pptx/references/styles/${style.id}.md 与 pptx/references/skeletons/${density}.md。`,
    `必须通过 pptx/scripts/style_runtime.js 的 loadStyle('${style.id}', { density: '${density}', brand: '${accent}' }) 解析主题，使用 text/card/furniture，禁止手抄圆角和阴影参数。`,
    `圆角 ${style.shape.radius}pt 是主题规格，rectRadius 必须除以 72 并按卡片短边限制；禁止直接传 ${style.shape.radius} 作为英寸。`,
    `页面底色 #${style.tokens.bg}；正文 #${style.tokens.ink}；强调色 #${accent}。${style.presentation.rules ? '允许主题定义的细分隔线。' : '不用页眉页脚分隔线，以留白分区。'}`,
    style.shape.shadow ? `阴影必须显式指定颜色 ${style.presentation.shadowColor}、透明度 ${style.presentation.shadowOpacity}、偏移 ${style.presentation.shadowOffset}pt；每个形状仅一个柔和阴影。` : '不加阴影。',
    style.id === 'D2' ? '玻璃卡片白色填充 transparency:40（60% 不透明），不要求原生 PPTX 无法实现的背景模糊。' : '',
    '中文标题和正文使用中文字体，数字使用数字字体；密度只改变内容量和字号，不覆盖主题的形状语言。',
    '有 KPI 行时使用 theme.kpiRow，按返回 bodyY/bodyH 布置后续内容；六个指标不能与正文共用同一个起点。剩余高度不足就拆页。',
    '一页一个主视觉焦点；不要把所有柱子都染成强调色；不要每页强塞图表、表格和结论框。文字放不下先精简或拆页，不靠缩小字号。',
    '生成后检查结构、图表、字体、风格，并 ReviewDocument 查看各页；修复重叠、胶囊化、重阴影和文字溢出后交付。',
  ].filter(Boolean).join('\n');
}
